import { useFirstMountState, useMountEffect, useSyncedRef } from "@react-hookz/web";
import Cookies from "js-cookie";
import { useCallback, useState } from "react";
export const useCookieValue = (cookieName, options) => {
  const latestOptions = useSyncedRef(options);
  const isFirstMount = useFirstMountState();
  const {
    0: value,
    1: setValue
  } = useState(() => {
    if (isFirstMount && options !== null && options !== void 0 && options.initializeWithValue) return Cookies.get(cookieName) ?? null;
    return null;
  });
  const updateCookie = useCallback(newValue => {
    Cookies.set(cookieName, newValue, latestOptions.current);
    setValue(newValue);
  }, [cookieName, latestOptions]);
  const deleteCookie = useCallback(() => {
    Cookies.remove(cookieName);
    setValue(null);
  }, [cookieName]);
  useMountEffect(() => {
    const cookieValue = Cookies.get(cookieName);
    if (value || !cookieValue) return;
    setValue(cookieValue);
  });

  // eslint-disable-next-line @shopify/react-hooks-strict-return
  return [value, updateCookie, deleteCookie];
};